import { OrderDetailItem } from '@shared/types/order';
import { Link } from 'react-router-dom';

interface ProductItemProps {
    product: OrderDetailItem
}

export default function ProductItem({ product }: ProductItemProps) {
    const formatPrice = (price: number) => {
        return new Intl.NumberFormat('ja-JP').format(price);
    };

    return (
        <Link to={`/publications/${product.publication_id}`} className='block'>
            <div className='bg-[#F1F5F9] rounded-lg px-3 py-2 flex gap-4 items-center'>
                <img
                    src={product.image_url}
                    alt={product.publication_name}
                    className='h-[100px] aspect-book object-cover border border-white flex-shrink-0 hover:opacity-80 transition-opacity'
                />
                <div className='flex-1 min-w-0 space-y-1.5'>
                    <h4 className='text-sm line-clamp-2 hover:text-primary transition-colors'>
                        {product.publication_name}
                    </h4>
                    {product.author && (
                        <p className='text-xs text-text-secondary line-clamp-1'>
                            著者：
                            {product.author}
                        </p>
                    )}
                    <div className='flex items-center gap-6'>
                        <p className='text-xs text-text-secondary'>
                            数量：1
                        </p>
                        <p className='text-sm font-bold text-danger'>
                            ¥
                            {formatPrice(product.price)}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    );
}
